import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Adds a gentle fade-and-rise as sections scroll into view.
   Targets common section/card selectors so pages do not each need wiring. */
const SELECTORS = [
  ".home-outcomes",
  ".home-block",
  ".home-cta",
  ".ix-section",
  ".ix-card",
  ".lab-release",
  ".pr-flagship",
].join(",");

function RevealManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const els = Array.from(document.querySelectorAll(SELECTORS));

    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    els.forEach((el) => el.classList.add("ix-reveal"));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, [pathname]);

  return null;
}

export default RevealManager;
